import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const Counter = () => {

  const { ref, inView, entry } = useInView({
    threshold: 0,
  });



  const [padding, setPadding] = useState('30px 0px 10px 0px');
  useEffect(() => {
    const updatePadding = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setPadding('30px 0px 10px 0px');
      } else if (width < 768) {
        setPadding('40px 0px 18px 0px');
      } else {
        setPadding('50px 0px 25px 0px');
      }
    };

    updatePadding();
    window.addEventListener('resize', updatePadding);

    return () => {
      window.removeEventListener('resize', updatePadding);
    };
  }, []);



  const counterData = [
    {
      id: 1,
      counter: <CountUp start={0} end={20} duration={2} delay={0}></CountUp>,
      label: "+年",
      title: "法律經驗",
    },
    {
      id: 2,
      counter: <CountUp start={0} end={30} duration={2} delay={0}></CountUp>,
      label: "+位",
      title: "律師及法律專家",
    },
    {
      id: 3,
      counter: <CountUp start={0} end={40} duration={2} delay={0}></CountUp>,
      label: "+",
      title: "類型常見合約",
    },
    {
      id: 4,
      counter: <CountUp start={0} end={100} duration={2} delay={0}></CountUp>,
      label: "+家",
      title: "上市櫃企業導入 AI 科技",
    },
  ];

  return (

    <div ref={ref} className="counter-area pb-75 style-2"
      style={{
        backgroundColor: '#f5f5f5',
        padding: padding,
      }}
    >
      <div className="container">
        <div className="row" data-cues="fadeIn">
          {counterData.map(({ counter, id, title, label }) => (
            <div key={id} className="col-lg-3 col-sm-6">
              <div className="single-counter-card style-2">

                {inView && 
                  <h2 style={{ color: '#317c73', fontWeight: '600' }}>
                    <span className="counter">{counter}</span> 
                    <span>{label}</span> 
                  </h2>
                }
                <p style={{ color: '#272b3a', fontSize: '18px' }}>{title}</p>

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

  );

}

export default Counter;


